module.exports = __webpack_public_path__ + "media/images/landing/studies/emco-45e4bc4f50e10746b6abd30f5452f78e.jpg";